<form [formGroup]="note40Form">
  <div class="notes-wrapper">
    <div class="notes-section">
      <p class="fw-bold notes-heading">
        Details of material funds held and movements during the CURRENT
        reporting period
      </p>
      <table class="notes-table" aria-describedby="User Task Table">
        <tr>
          <th rowspan="2" scope="col">Fund names</th>
          <th scope="col">Fund balances brought forward</th>
          <th scope="col">Income</th>
          <th scope="col">Expenditure</th>
          <th scope="col">Transfers</th>
          <th scope="col">Gains and losses</th>
          <th scope="col">Fund balances carried forward</th>
        </tr>
        <tr>
          <th scope="col" class="fw-bold">£</th>
          <th scope="col" class="fw-bold">£</th>
          <th scope="col" class="fw-bold">£</th>
          <th scope="col" class="fw-bold">£</th>
          <th scope="col" class="fw-bold">£</th>
          <th scope="col" class="fw-bold">£</th>
        </tr>
        <ng-container
          *ngIf="calculativeData?.fundDataCurrentPeriod?.length === 0"
        >
          <tr>
            <td colspan="9" class="text-align-center mt-1 fw-bold">
              <span>No records found</span>
            </td>
          </tr>
        </ng-container>
        <ng-container
          *ngIf="calculativeData?.fundDataCurrentPeriod?.length > 0"
        >
          <ng-container
            *ngIf="
              filterItems(
                calculativeData?.fundDataCurrentPeriod,
                'unrestricted'
              ).length > 0
            "
          >
            <tr>
              <td class="fw-bold text-align-left" colspan="7">
                Unrestricted funds
              </td>
            </tr>
            <tr
              *ngFor="
                let item of filterItems(
                  calculativeData?.fundDataCurrentPeriod,
                  'unrestricted'
                )
              "
            >
              <td class="text-align-left">{{ item.name }}</td>
              <td class="fw-bold">
                {{ item.balanceBroughtForward | numberPipe }}
              </td>
              <td class="fw-bold">{{ item.income | numberPipe }}</td>
              <td class="fw-bold">{{ item.expenditure | numberPipe }}</td>
              <td class="fw-bold">{{ item.transfers | numberPipe }}</td>
              <td class="fw-bold">{{ item.gainAndLoss | numberPipe }}</td>
              <td class="fw-bold">
                {{ item.carriedForward | numberPipe }}
              </td>
            </tr>
          </ng-container>
          <ng-container
            *ngIf="
              filterItems(calculativeData?.fundDataCurrentPeriod, 'restricted')
                .length > 0
            "
          >
            <tr>
              <td class="fw-bold text-align-left" colspan="7">
                Restricted funds
              </td>
            </tr>
            <tr
              *ngFor="
                let item of filterItems(
                  calculativeData?.fundDataCurrentPeriod,
                  'restricted'
                )
              "
            >
              <td class="text-align-left">{{ item.name }}</td>
              <td class="fw-bold">
                {{ item.balanceBroughtForward | numberPipe }}
              </td>
              <td class="fw-bold">{{ item.income | numberPipe }}</td>
              <td class="fw-bold">{{ item.expenditure | numberPipe }}</td>
              <td class="fw-bold">{{ item.transfers | numberPipe }}</td>
              <td class="fw-bold">{{ item.gainAndLoss | numberPipe }}</td>
              <td class="fw-bold">
                {{ item.carriedForward | numberPipe }}
              </td>
            </tr>
          </ng-container>
          <ng-container
            *ngIf="
              filterItems(calculativeData?.fundDataCurrentPeriod, 'endowment')
                .length > 0
            "
          >
            <tr>
              <td class="fw-bold text-align-left" colspan="7">
                Endowment funds
              </td>
            </tr>
            <tr
              *ngFor="
                let item of filterItems(
                  calculativeData?.fundDataCurrentPeriod,
                  'endowment'
                )
              "
            >
              <td class="text-align-left">{{ item.name }}</td>
              <td class="fw-bold">
                {{ item.balanceBroughtForward | numberPipe }}
              </td>
              <td class="fw-bold">{{ item.income | numberPipe }}</td>
              <td class="fw-bold">{{ item.expenditure | numberPipe }}</td>
              <td class="fw-bold">{{ item.transfers | numberPipe }}</td>
              <td class="fw-bold">{{ item.gainAndLoss | numberPipe }}</td>
              <td class="fw-bold">
                {{ item.carriedForward | numberPipe }}
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </table>
    </div>
    <div class="notes-section">
      <ejs-richtexteditor
        [toolbarSettings]="
          commonService.syncfusionRichTextEditorToolbarSettings
        "
        (actionBegin)="
          commonService.syncfusionRichTextEditorOnActionBegin($event)
        "
        [enableXhtml]="true"
        [toolbarSettings]="commonService.syncfusionRichTextEditorTools"
        formControlName="textbox1"
        [enableHtmlSanitizer]="true"
        [pasteCleanupSettings]="
          commonService.syncfusionRichTextEditorPasteCleanupSettings
        "
      ></ejs-richtexteditor>
    </div>
    <div class="notes-section">
      <p class="fw-bold notes-heading">
        Details of material funds held and movements during the PREVIOUS
        reporting period
      </p>
      <table class="notes-table" aria-describedby="Note Table">
        <tr>
          <th rowspan="2" scope="col">Fund names</th>
          <th scope="col">Fund balances brought forward</th>
          <th scope="col">Income</th>
          <th scope="col">Expenditure</th>
          <th scope="col">Transfers</th>
          <th scope="col">Gains and losses</th>
          <th scope="col">Fund balances carried forward</th>
        </tr>
        <tr>
          <th scope="col" class="fw-bold">£</th>
          <th scope="col" class="fw-bold">£</th>
          <th scope="col" class="fw-bold">£</th>
          <th scope="col" class="fw-bold">£</th>
          <th scope="col" class="fw-bold">£</th>
          <th scope="col" class="fw-bold">£</th>
        </tr>
        <ng-container
          *ngIf="calculativeData?.fundDataPreviousPeriod?.length === 0"
        >
          <tr>
            <td colspan="9" class="text-align-center mt-1 fw-bold">
              <span>No records found</span>
            </td>
          </tr>
        </ng-container>
        <ng-container
          *ngIf="calculativeData?.fundDataPreviousPeriod?.length > 0"
        >
          <ng-container
            *ngIf="
              filterItems(
                calculativeData?.fundDataPreviousPeriod,
                'unrestricted'
              ).length > 0
            "
          >
            <tr>
              <td class="fw-bold text-align-left" colspan="7">
                Unrestricted funds
              </td>
            </tr>
            <tr
              *ngFor="
                let item of filterItems(
                  calculativeData?.fundDataPreviousPeriod,
                  'unrestricted'
                )
              "
            >
              <td class="text-align-left">{{ item.name }}</td>
              <td class="fw-bold">
                {{ item.balanceBroughtForward | numberPipe }}
              </td>
              <td class="fw-bold">{{ item.income | numberPipe }}</td>
              <td class="fw-bold">{{ item.expenditure | numberPipe }}</td>
              <td class="fw-bold">{{ item.transfers | numberPipe }}</td>
              <td class="fw-bold">{{ item.gainAndLoss | numberPipe }}</td>
              <td class="fw-bold">
                {{ item.carriedForward | numberPipe }}
              </td>
            </tr>
          </ng-container>
          <ng-container
            *ngIf="
              filterItems(calculativeData?.fundDataPreviousPeriod, 'restricted')
                .length > 0
            "
          >
            <tr>
              <td class="fw-bold text-align-left" colspan="7">
                Restricted funds
              </td>
            </tr>
            <tr
              *ngFor="
                let item of filterItems(
                  calculativeData?.fundDataPreviousPeriod,
                  'restricted'
                )
              "
            >
              <td class="text-align-left">{{ item.name }}</td>
              <td class="fw-bold">
                {{ item.balanceBroughtForward | numberPipe }}
              </td>
              <td class="fw-bold">{{ item.income | numberPipe }}</td>
              <td class="fw-bold">{{ item.expenditure | numberPipe }}</td>
              <td class="fw-bold">{{ item.transfers | numberPipe }}</td>
              <td class="fw-bold">{{ item.gainAndLoss | numberPipe }}</td>
              <td class="fw-bold">
                {{ item.carriedForward | numberPipe }}
              </td>
            </tr>
          </ng-container>
          <ng-container
            *ngIf="
              filterItems(calculativeData?.fundDataPreviousPeriod, 'endowment')
                .length > 0
            "
          >
            <tr>
              <td class="fw-bold text-align-left" colspan="7">
                Endowment funds
              </td>
            </tr>
            <tr
              *ngFor="
                let item of filterItems(
                  calculativeData?.fundDataPreviousPeriod,
                  'endowment'
                )
              "
            >
              <td class="text-align-left">{{ item.name }}</td>
              <td class="fw-bold">
                {{ item.balanceBroughtForward | numberPipe }}
              </td>
              <td class="fw-bold">{{ item.income | numberPipe }}</td>
              <td class="fw-bold">{{ item.expenditure | numberPipe }}</td>
              <td class="fw-bold">{{ item.transfers | numberPipe }}</td>
              <td class="fw-bold">{{ item.gainAndLoss | numberPipe }}</td>
              <td class="fw-bold">
                {{ item.carriedForward | numberPipe }}
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </table>
    </div>
    <div class="notes-section">
      <ejs-richtexteditor
        [toolbarSettings]="
          commonService.syncfusionRichTextEditorToolbarSettings
        "
        (actionBegin)="
          commonService.syncfusionRichTextEditorOnActionBegin($event)
        "
        [enableXhtml]="true"
        [toolbarSettings]="commonService.syncfusionRichTextEditorTools"
        formControlName="textbox2"
        [enableHtmlSanitizer]="true"
        [pasteCleanupSettings]="
          commonService.syncfusionRichTextEditorPasteCleanupSettings
        "
      ></ejs-richtexteditor>
    </div>

    <div class="notes-section">
      <p class="fw-bold notes-heading">Transfers between funds</p>

      <p class="fw-bold">This year</p>
      <table class="notes-table" aria-describedby="Note Table">
        <tr>
          <th></th>
          <th>Amount</th>
          <!-- <th></th> -->
        </tr>

        <!-- Row 1 -->
        <tr>
          <td class="text-align-left">Between unrestricted and restricted funds</td>
          <td *ngIf="!showInput1" (click)="showInput(1)">
            {{ note40Form.get('thisYearAmount1')?.value | numberPipe }}
          </td>
          <td *ngIf="showInput1">
            <mat-form-field class="w-130">
              <input matInput formControlName="thisYearAmount1" (blur)="resetIfEmpty('thisYearAmount1')" autocomplete="off" />
            </mat-form-field>
          </td>
        </tr>

        <!-- Row 2 -->
        <tr>
          <td class="text-align-left">Between endowment and restricted funds</td>
          <td *ngIf="!showInput2" (click)="showInput(2)">
            {{ note40Form.get('thisYearAmount2')?.value | numberPipe }}
          </td>
          <td *ngIf="showInput2">
            <mat-form-field class="w-130">
              <input matInput formControlName="thisYearAmount2" (blur)="resetIfEmpty('thisYearAmount2')" autocomplete="off" />
            </mat-form-field>
          </td>
        </tr>

        <!-- Row 3 -->
        <tr>
          <td class="text-align-left">Between endowment and unrestricted funds</td>
          <td *ngIf="!showInput3" (click)="showInput(3)">
            {{ note40Form.get('thisYearAmount3')?.value | numberPipe }}
          </td>
          <td *ngIf="showInput3">
            <mat-form-field class="w-130">
              <input matInput formControlName="thisYearAmount3" (blur)="resetIfEmpty('thisYearAmount3')" autocomplete="off" />
            </mat-form-field>
          </td>
        </tr>
      </table>

      <br />

      <p class="fw-bold">Last year</p>
      <table class="notes-table" aria-describedby="Note Table">
        <tr>
          <th></th>
          <th>Amount</th>
          <!-- <th></th> -->
        </tr>

        <!-- Row 4 -->
        <tr>
          <td class="text-align-left">Between unrestricted and restricted funds</td>
          <td *ngIf="!showInput4" (click)="showInput(4)">
            {{ note40Form.get('lastYearAmount1')?.value | numberPipe }}
          </td>
          <td *ngIf="showInput4">
            <mat-form-field class="w-130">
              <input matInput formControlName="lastYearAmount1" (blur)="resetIfEmpty('lastYearAmount1')" autocomplete="off" />
            </mat-form-field>
          </td>
        </tr>

        <!-- Row 5 -->
        <tr>
          <td class="text-align-left">Between endowment and restricted funds</td>
          <td *ngIf="!showInput5" (click)="showInput(5)">
            {{ note40Form.get('lastYearAmount2')?.value | numberPipe }}
          </td>
          <td *ngIf="showInput5">
            <mat-form-field class="w-130">
              <input matInput formControlName="lastYearAmount2" (blur)="resetIfEmpty('lastYearAmount2')" autocomplete="off" />
            </mat-form-field>
          </td>
        </tr>

        <!-- Row 6 -->
        <tr>
          <td class="text-align-left">Between endowment and unrestricted funds</td>
          <td *ngIf="!showInput6" (click)="showInput(6)">
            {{ note40Form.get('lastYearAmount3')?.value | numberPipe }}
          </td>
          <td *ngIf="showInput6">
            <mat-form-field class="w-130">
              <input matInput formControlName="lastYearAmount3" (blur)="resetIfEmpty('lastYearAmount3')" autocomplete="off" />
            </mat-form-field>
          </td>
        </tr>
      </table>
    </div>


    <div class="notes-section">
      <ejs-richtexteditor
        [toolbarSettings]="
          commonService.syncfusionRichTextEditorToolbarSettings
        "
        (actionBegin)="
          commonService.syncfusionRichTextEditorOnActionBegin($event)
        "
        [enableXhtml]="true"
        [toolbarSettings]="commonService.syncfusionRichTextEditorTools"
        formControlName="textbox3"
        [enableHtmlSanitizer]="true"
        [pasteCleanupSettings]="
          commonService.syncfusionRichTextEditorPasteCleanupSettings
        "
      ></ejs-richtexteditor>
    </div>
    <div class="notes-section">
      <p class="fw-bold notes-heading">Designated funds</p>
      <ejs-richtexteditor
        [toolbarSettings]="
          commonService.syncfusionRichTextEditorToolbarSettings
        "
        (actionBegin)="
          commonService.syncfusionRichTextEditorOnActionBegin($event)
        "
        [enableXhtml]="true"
        [toolbarSettings]="commonService.syncfusionRichTextEditorTools"
        formControlName="textbox4"
        [enableHtmlSanitizer]="true"
        [pasteCleanupSettings]="
          commonService.syncfusionRichTextEditorPasteCleanupSettings
        "
      ></ejs-richtexteditor>
    </div>
  </div>
</form>
